import { ThemeVariables } from '@material-ui/core/styles/createMuiTheme';

const variables: ThemeVariables = {
  drawerWidth: 275,
  headerHeight: 56,
  headerHeightUpSm: 64,
  tabbarHeight: 48,
  contentPadding: 0,
  contentPaddingUpSm: 24,
  boxShadow:
    '0px 3px 5px -1px rgba(0, 0, 0, 0.2), 0px 5px 8px 0px rgba(0, 0, 0, 0.14), 0px 1px 14px 0px rgba(0, 0, 0, 0.12)',
  funnelConversionHeight: 265,
  funnelConversionFunnel: 265 / 2.5,
  colors: {
    success: '#009358',
    successHover: '#017446',
    error: '#dc3f53',
    title: '#596375',
    text: '#596375',
    label: '#596375',
    chartStroke: '#92cdda',
    chartFill: '#ccebf1',
    customizerAppBarBackground: '#192542',
    link: '#F59211',
    customizerTitle: '#192542',
    inputBorder: '#D9D9D9',
    inputColorHover: '#192542',
    funnelAccess: '#596375',
    funnelInvoices: '#FABB0A',
    funnelConversion: '#192542',
    tabsIndicator: '#FABB0A',
    drawerBackground: '#122D44',
    primaryColor: '#265AAB',
    buttonBackgroundHover: '#051e56',
    cardPrimaryColor: '#3250A6'
  }
};

export default variables;
